import React, { useRef } from 'react'
import Hero from '../components/Hero'
import Popular from '../components/Popular'
import Offers from '../components/Offers'
import NewCollections from '../components/NewCollections'
import NewsLetter from '../components/NewsLetter'

const Shop = () => {

  const newCollectionRef = useRef(null)

  const scrollToNewCollection = () => {
    newCollectionRef.current?.scrollIntoView({
      behavior: "smooth",
      block: "start"
    })
  }

  return (
    <div>
      <Hero onScrollToCollection={scrollToNewCollection} />
      <Popular />
      <Offers />
      <NewCollections ref={newCollectionRef} />
      <NewsLetter />
    </div>
  )
}

export default Shop